import React from 'react';
import ConfirmationModal from 'components/confirmationModal/confirmationModal';
import { getAvatarNameView } from 'utils';
import { FaCamera } from 'react-icons/fa';
import { Box , Button, Flex, Icon, Spinner , Avatar, Text } from '@chakra-ui/react';
import { useUpdateAvatarMutation , useGetDocumenturlMutation } from 'reducers/Document.service';
import { CONSUMER_TYPE } from 'constants/index';

export default function ChangeAvatar({ id, data , refetch, deleteAvatar }) {
    const [avatar, setavatar] = React.useState(null);
    const [getDocumentUrl] = useGetDocumenturlMutation();
    const [isOpen, setisOpen] = React.useState(false);

    const [updateAvatar, { isLoading: updateAvatarLoading }] = useUpdateAvatarMutation();

    const handleDeleteAvatar = ()=>{
        setisOpen(false);
        deleteAvatar();
    };

    const onClickDelete = ()=>{
        setisOpen(true);
    };
    const fileInputRef = React.useRef(null);

    const handlePhotoUpload = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSizeInBytes = 3 * 1024 * 1024;
        if (!allowedTypes.includes(file.type)) {
            alert('Only JPEG and PNG files are allowed.');
            return;
        }
        if (file.size > maxSizeInBytes) {
            alert('File size must be less than or equal to 3MB.');
            return;
        }
        const formdata = new FormData();
        formdata.append('avatar', file);

        // update avatar
        updateAvatar({ id , body: formdata, USERTYPE: data?.userType }).unwrap().then(()=>{
            refetch();
        });
    };
    React.useEffect(() => {
        if (data) {
            if (data?.userType === CONSUMER_TYPE) {
                getDocumentUrl({ url: data?.avatar }).unwrap().then((res) => {
                    setavatar(res);
                }).catch(() => {
                    setavatar(null);
                });
            } else {
                setavatar(data?.avatar);
            }
        }
    }, [data]);

    return (
        <React.Fragment>
            <ConfirmationModal
                isOpen={isOpen}
                title={'Delete Avatar'}
                onOpen={setisOpen}
                onClose={()=>setisOpen(false)}
                onActionConfirm={handleDeleteAvatar}
                modalBody="Are you sure you want to delete this avatar?"
            />
            <Box borderBottom="1px solid #E2E8F0" pb={2}>
                <Flex justify="space-between" align="center">
                    <Text fontWeight="bold">PROFILE PHOTO</Text>
                    <Button disabled={updateAvatarLoading} onClick={handlePhotoUpload} color="teal.500" display="flex" alignItems="center" fontSize="sm">
                        <Icon as={FaCamera} w={4} h={4} mr={1} />
                                        Change Photo
                    </Button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                </Flex>
            </Box>
            {
                (updateAvatarLoading)
                    ? <Box width={'100%'} height={'30%'} textAlign={'center'}>
                        <Spinner
                            thickness="4px"
                            speed="0.65s"
                            mt={'15%'}
                            emptyColor="var(--primary-border)"
                            color="var(--primary-color)"
                            size="xl"
                        />
                        <p>Loading avatar please wait...</p>
                    </Box>
                    : <Avatar
                        Avatar
                        size="2xl"
                        src={ avatar}
                        name={getAvatarNameView(data)}
                        width="100%"
                        height='30%'
                        borderRadius="md"
                        boxShadow="xl"
                        mt={8}
                    />
            }
            <Box display="flex" justifyContent="center" mt="8">
                <Button
                    onClick={onClickDelete}
                    fontSize="sm"
                    color="red.500"
                    cursor="pointer"
                >
                                    Delete Photo
                </Button>
            </Box>
        </React.Fragment>
    );
}
